// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"dce59329","732":"11162ed6","977":"24043f4b"}[chunkId] + ".chunk.js";
};